import { ReactElement } from 'react';
import { useIsMobile } from '@synergy/components-next';

import { SupplierTableDesktop } from './desktop/supplier-table-desktop';
import { SupplierTableMobile } from './mobile/supplier-table-mobile';
import { WishListSupplier } from '../../../models/wish-list';

export interface SupplierTableProps {
    supplier: WishListSupplier;
}

export const SupplierTable = (props: SupplierTableProps): ReactElement => {
    const isMobile = useIsMobile();
    const { supplier } = props;

    return isMobile ? <SupplierTableMobile supplier={supplier} /> : <SupplierTableDesktop supplier={supplier} />;
};
